export type GainsightAction = 'set' | 'setOnce' | 'track' | 'remove';

export type GainsightAttributes = {
	[x: string]: string | number | boolean | Date | undefined;
};

export interface CallGainsightParams {
	action: GainsightAction;
	actionTarget?: string;
	attrs?: GainsightAttributes;
	clientId: string;
}

export interface CallGainsightTrackEventParams {
	actionTarget?: string;
	attrs?: GainsightAttributes;
	clientId: string;
}
